import React, { useCallback, useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiMaskPaintPreview from "../../shared/Popup/AiMaskPaintPreview";
import AiMaskSelectToolControls, {
  isMaskSelectGenerateReady,
} from "../../shared/Popup/AiMaskSelectToolControls";
import { useAiMaskPaint } from "../../shared/Popup/useAiMaskPaint";

/**
 * AI Tools → AI Remove Text prep (Smart / Brush / Box / Eraser).
 */
const RemoveTextToolPrep = (props) => {
  const [prompt, setPrompt] = useState("");
  const paint = useAiMaskPaint();
  const toolId = paint.paintTool;

  const isGenerateReady = useCallback(
    () => isMaskSelectGenerateReady(toolId, paint.hasMask),
    [toolId, paint.hasMask]
  );

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_remove_text"
      title="AI Remove Text"
      aka="Text Remover"
      bio="Clean text and overlays while reconstructing what’s underneath."
      emptyPreviewLabel="Upload an image to preview text removal"
      loadingLabel="Removing text…"
      emptyFooterHint="Upload an image, pick a tool, then generate."
      isGenerateReady={isGenerateReady}
      renderPreview={({
        imageUrl,
        loading,
        loadingLabel,
        emptyLabel,
        hasResult,
      }) => (
        <AiMaskPaintPreview
          ref={paint.maskRef}
          imageUrl={imageUrl}
          loading={loading}
          loadingLabel={loadingLabel}
          emptyLabel={emptyLabel}
          tool={toolId}
          brushSize={paint.brushSize}
          paintEnabled={
            !hasResult &&
            Boolean(imageUrl) &&
            !loading &&
            toolId !== "smart"
          }
          clearVersion={paint.clearVersion}
          onMaskChange={paint.handleMaskChange}
        />
      )}
      renderControls={({ busy, leftPanelRef, sourceImageUrl }) => (
        <>
          <AiMaskSelectToolControls
            paint={paint}
            busy={busy}
            sourceImageUrl={sourceImageUrl}
            leftPanelRef={leftPanelRef}
            subject="text"
          />

          <div className="aftp-section">
            <label className="aftp-label" htmlFor="aftp-rt-prompt">
              Which text to remove
              <span className="aftp-optional"> (optional)</span>
            </label>
            <textarea
              id="aftp-rt-prompt"
              className="aftp-input"
              rows={3}
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              placeholder="e.g. the caption at the bottom, the date stamp"
              disabled={busy}
            />
          </div>
        </>
      )}
    />
  );
};

export default RemoveTextToolPrep;
